// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../../Button';
import AssessmentImage from '../../../../../assets/images/assessment-page-icon.png';
import Row from '../../../../Row';

export const S = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  `,
  Row: styled(Row)`
    align-items: center;
    margin-top: 41px;

    & div {
      margin-right: 36px;
    }
  `,
  InformationContainer: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
  `,
  Title: styled.div`
    font: 700 20px Noto Sans TC;
    color: #434343;
    line-height: 29px;
    text-align: center;
    margin-bottom: 14px;
  `,
  Subtitle: styled.div`
    font: 400 18px Noto Sans TC;
    color: #434343;
  `,
  AssessmentImage: styled.img.attrs({ src: AssessmentImage, alt: 'assessment-image' })`
    width: 220px;
    height: 220px;
  `,
  TextButton: styled.div`
    width: 142px;
    font-family: Noto Sans TC;
    font-size: 18px;
    line-height: 26px;
    color: #EF8200;
    cursor: pointer;
  `,
  Button: styled(Button)`
    width: 142px;
  `
};
